<div class="status-reason">
  @if (iconSrc) {
    <ion-img [src]="iconSrc"></ion-img>
  }
  <div class="text-container">
    <p class="heading">{{ heading }}</p>
    @if (message) {
      <p class="message">{{ message }}</p>
    }
  </div>
</div>
